import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from '@/assets/icons/icons.js'
import './helpers/formValidation'

const app = createApp(App)

app.use(router)
app.use(store)
app.use(icons)
app.use(CoreuiVue)

// global method
app.config.globalProperties.$scrollToTop = () => {
  try {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  } catch (e) {
    window.scrollTo(0, 0)
  }
}

app.mount('#app')
